import React, { Component } from 'react';
import './SubNavbar.css';
import { post, get } from '../../custom_libraries/serverRequests';
import globalVariables from '../../custom_libraries/globalVariables';
// import { getFreshToken } from '../../custom_libraries/auth';
import urls from '../../custom_libraries/urls';
import { Button} from '@mui/material';
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
import Backdrop from '@mui/material/Backdrop';
import WebLogo from '../../assets/Artboard 1Bonus.png';

class EmailAddresses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // emails: "",
      emails: [""], // 1 default email inputs
      error: "",
      success: false,
      error2: false,
      error1 :false,
      warning : false,
      success_report : false,
      warning_report : false,
      open_progress_bar: false,
    };
  }

  componentDidMount() {
    this.fetchUserSettings();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
        this.state.error !== prevState.error ||
        this.state.error1 !== prevState.error1 ||
        this.state.success !== prevState.success ||
        this.state.warning !== prevState.warning ||
        this.state.warning_report !== prevState.warning_report ||
        this.state.success_report !== prevState.success_report
    ) {
        if (
            this.state.error ||
            this.state.error1 ||
            this.state.success ||
            this.state.warning ||
            this.state.warning_report ||
            this.state.success_report
        ) {
            setTimeout(() => {
                this.setState({
                    error: false,
                    success:false,
                    error1: false,
                    warning : false,
                    success_report : false,
                    warning_report : false,
                });
            }, 3000); // 3 second
        }
    }
}

  validateEmails = (email) => {
    // const emailRegex =
    //   /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(, *[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})*$/;
    // return emailRegex.test(emailList);
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  handleInputChange = (index, value) => {
    // const input = e.target.value;
    // this.setState({ emails: input });

    // if (input && !this.validateEmails(input)) {
    //   this.setState({ error: "Invalid email format. Use comma-separated emails." });
    // } else {
    //   this.setState({ error: "" });
    // }
    const emails = [...this.state.emails];
    emails[index] = value;
    this.setState({ emails });

    // Validate the individual email
    if (value && !this.validateEmails(value)) {
      this.setState({ error: `Invalid email format at position ${index + 1}.` });
    } else {
      this.setState({ error: "" });
    }
  };


  fetchUserSettings = async () => {
    console.log("--------EmailAddress tab---------" );
    try {
      this.startLoading();
      let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN)
      console.log("--------auth token---------", access_token);
      let headers = {
          'content-type': 'application/json',
          'Authorization': `Bearer ${access_token}`
      }

      const response = await get(urls.NOTIFICATION_SETTINGS_LIST, headers);
      
      console.log("response of email fetch===> <", response);
      this.stopLoading();
      if (response !== false) {
        // this.setState({ emails: response[0].email_addresses });
        const emailString = response[0].email_addresses || "";
        const emailArray = emailString ? emailString.split(",").map(email => email.trim()) : ["", "", ""];
        this.setState({ emails: emailArray.length ? emailArray : ["", "", ""] });
      }
    } catch (error) {
      console.error("Error fetching user settings:", error);
      // this.setState({error1:true});
    }
  };

  jsonData = () => {
    let data = {
        "email_addresses": this.state.emails.join(","),
    }
    return JSON.stringify(data)
  }


  handleSave = async() => {
    const { emails } = this.state;

    if (!emails) {
      // alert("No emails provided. Emails not saved.");
      this.setState({warning: true})
      return;
    }
    this.startLoading();
    let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN)
            console.log("--------auth token---------", access_token);
            let headers = {
                'content-type': 'application/json',
                'Authorization': `Bearer ${access_token}`
            }
            console.log("--------headers---------", headers);

    let response = await post(urls.NOTIFICATION_SETTINGS_CREATE, this.jsonData(), headers);
    console.log("response of email save===> ", response);
    this.stopLoading();
    if (response!==false) {
      // alert("Settings saved successfully.");
      this.setState({success: true})
    } else {
      // alert("Error saving emails. Please try again.");
      this.setState({error2: true})
    }
  };

  handleDemoReport = () => {
    const { emails } = this.state;

    if (this.validateEmails(emails)) {
      // alert(`Sending demo report to: ${emails}`);
      this.setState({success_report: true});
    } else {
      // alert("Please enter valid email(s) to send the report.");
      this.setState({warning_report: true})
    }
  };

  startLoading = () => {
    this.setState({ open_progress_bar: true})
  }
  
  stopLoading = () => {
      this.setState({ open_progress_bar: false})
  }

  addEmailField = () => {
    this.setState((prevState) => ({
      emails: [...prevState.emails, ""],
    }));
  };

  removeEmailField = (index) => {
    this.setState((prevState) => {
      const emails = [...prevState.emails];
      emails.splice(index, 1); // remove the email at the given index
      return { emails };
    });
  };

  render() {
    const { emails, error, error2, success_report, warning_report, success, error1, warning, } = this.state;
    

    return (
      <div>
        <>
          <div style={{marginLeft:'15%', width:'80%'}}>
              { error2 ? (
                          <Alert severity="error">Error saving emails. Please try again.!</Alert>
                      ) : success ? (
                          <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                              "Settings saved successfully."
                          </Alert>
                      ) : success_report ? (
                        <Alert severity="error">
                            "Sending demo report to: ${emails}"
                        </Alert>
                        ) : warning_report ? (
                          <Alert severity="error">
                              "Please enter valid email(s) to send the report."
                          </Alert>
                          ) : error1 ? (
                            <Alert severity="error">
                                "Server Error occured while fetching user email..."
                            </Alert>
                            ) : warning ? (
                              <Alert severity="error">
                                  "No emails provided. Email not saved."
                              </Alert>
                              ) : null} 
          </div>
          <div className='email-address' style={{ maxWidth: "50%", marginTop: "5%" }}>
            <h3>Email addresses</h3>
            <p style={{ fontSize: "14px", marginBottom: "10px", textAlign: "justify" }}>
            Please specify the email address(es) to receive this report. If you want
            to send emails to multiple addresses, please click on '+ADD' button to add new block and type only one email in each.
            </p>
            <div>
                {this.state.emails.map((email, index) => (
                  <div key={index} style={{ display: "flex", alignItems: "center", marginBottom: "8px", justifyContent:"center" }}>
                    <input
                      key={index}
                      type="email"
                      className="input-email"
                      value={email}
                      onChange={(e) => this.handleInputChange(index, e.target.value)}
                      placeholder={`Enter email ${index + 1}`}
                      style={{
                      display: "block", width: "100%" }}
                    />
                    <button
                      type="button"
                      onClick={() => this.removeEmailField(index)}
                      id="clearUserLogButton"
                      style={{
                        minWidth: "25px",
                        height: "31px",
                        
                      }}
                    >
                      -
                    </button>
                  </div>
                ))}
                
              </div>
            {error && <p style={{ color: "red", fontSize: "12px" }}>{error}</p>}
            <div style={{ marginTop: "10px" }}>
              
              <div>
                <Button
                  type="button"
                  onClick={this.addEmailField}
                  id="rowsPerPageButton"
                  style={{
                    minWidth:"25px",
                    // height:"34px",
                    marginTop:'6px'
                  }}
                >
                  + Add
                </Button>
                <Button id="rowsPerPageButton" style={{marginTop:'6px'}}
                  onClick={this.handleSave} 
                > Save
                </Button>
              </div>
            </div>
          </div>
        </>
        {/* Backdrop with Circular Progress */}
        <Backdrop open={this.state.open_progress_bar}>
          <div className="custom-spinner">
              <div className="circle"></div>
              <div className="circle tilted"></div>
              <img src={WebLogo} alt="web-logo" style={{backgroundColor:'#001f54', borderRadius:'100px'}}/>
          </div>
        </Backdrop>
      </div>
    );
  }
}

export default EmailAddresses;